import {EventEmitter} from 'fbemitter'

let windowStore = {}
const windowEmitter = new EventEmitter()

const Window = {
  setDialogState (newData) {
    windowStore = newData
    windowEmitter.emit('dialogStateChange')
  },
  getDialogState () {
    return windowStore
  },
  closeDialog () {
    Window.setDialogState({
      message: '',
      isOpen: false
    })
  },
  alert (message, onOKButtonClicked = null) {
    Window.setDialogState({
      type: 'alert',
      message: message,
      onOKButtonClicked: onOKButtonClicked,
      isOpen: true
    })
  },
  confirm (message, onYesButtonClicked = null, onNoButtonClicked = null) {
    Window.setDialogState({
      type: 'confirm',
      message: message,
      onYesButtonClicked: onYesButtonClicked,
      onNoButtonClicked: onNoButtonClicked,
      isOpen: true
    })
  },
  prompt (message, onSendButtonClicked = null, onCancelButtonClicked = null) {
    Window.setDialogState({
      type: 'prompt',
      message: message,
      onSendButtonClicked: onSendButtonClicked,
      onCancelButtonClicked: onCancelButtonClicked,
      isOpen: true
    })
  },
  addListener (eventType, fn) {
    return windowEmitter.addListener(eventType, fn)
  }
}

export default Window



// WEBPACK FOOTER //
// ./src/common/Window.js